"use client"
import { useCallback, useState } from 'react';
import Toast from './Toast';

export interface ToastMessage {
  id: string;
  message: string;
  type?: 'success' | 'error' | 'info';
  duration?: number;
}

export function useToast() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const showToast = useCallback((message: string, type: 'success' | 'error' | 'info' = 'success', duration = 3000) => {
    const id = Math.random().toString(36).substring(7);
    setToasts(prev => [...prev, { id, message, type, duration }]);
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  return { showToast, removeToast, toasts };
}

export function ToastContainer({ toasts, onRemove }: { toasts: ToastMessage[]; onRemove: (id: string) => void }) {
  if (toasts.length === 0) return null;

  return (
    <>
      {toasts.map((toast, index) => (
        <div
          key={toast.id}
          className="fixed top-4 right-4 z-[300]"
          style={{
            transform: `translateY(${index * 80}px)`,
            zIndex: 300 + index
          }}
        >
          <Toast
            message={toast.message}
            type={toast.type || 'success'}
            {...(toast.duration !== undefined ? { duration: toast.duration } : {})}
            onClose={() => onRemove(toast.id)}
          />
        </div>
      ))}
    </>
  );
}

